import React, { useState } from 'react';
import { Container } from '../../container/container';
import ImageGallery from 'react-image-gallery';
import { Fullscreen } from '../../fullscreen/fullscreen';
import PictureAsset from '../../asset/picture-asset';
import { Bullets } from './bullets';
import { useCallback } from 'react';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import clsx from 'clsx';
import styles from './slideshow.module.scss';
import { BreakOutContainer } from '../../container/break-out-container';

export const Slideshow = (props) => {
  const { slides = {}, slidesOnly = {}, pictureProps = {}, previewLimit = 4 } = props;
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);

  const imageClicked = useCallback((index) => {
    setGalleryIndex(index);
    setFullscreen(true);
  }, []);

  const mappedSlides = slides.length > 1 && slides.filter((slide) => !!slide.image.asset);
  const previewSlides = mappedSlides && mappedSlides.slice(0, previewLimit);

  return (
    <>
      {mappedSlides && (
        <>
          <BreakOutContainer>
            <Container className={clsx(styles.slideshow, slidesOnly && styles.slidesOnly)}>
              <div className={styles.previewWrapper}>
                {previewSlides.map(({ image }, index) => {
                  let id = (image.asset && image.asset._id) || index;
                  return (
                    <div
                      key={`${id}-key`}
                      onClick={() => imageClicked(index)}
                      className={styles.mobileSlide}
                      data-remaining-slide={
                        mappedSlides.length > previewLimit ? `+${mappedSlides.length - previewSlides.length}` : null
                      }
                    >
                      {slidesOnly ? (
                        <PictureAsset image={image} isFluid {...pictureProps} aspectRatio={1.1} />
                      ) : (
                        <PictureAsset image={image} isFluid aspectRatio={1} />
                      )}
                    </div>
                  );
                })}
              </div>
              <div className={styles.mobileSliderWrapper}>
                <ImageGallery
                  startIndex={galleryIndex}
                  showFullscreenButton={false}
                  showNav={false}
                  showThumbnails={false}
                  showPlayButton={false}
                  onSlide={(index) => setGalleryIndex(index)}
                  items={mappedSlides.map(({ image }, index) => {
                    let id = (image.asset && image.asset._id) || index;
                    return {
                      original: `${id}-key`,
                      renderItem: () => (
                        <div onClick={() => imageClicked(index)} className={styles.mobileSlide}>
                          {slidesOnly ? (
                            <PictureAsset image={image} isFluid {...pictureProps} aspectRatio={1.1} />
                          ) : (
                            <PictureAsset image={image} isFluid aspectRatio={1} />
                          )}
                        </div>
                      ),
                    };
                  })}
                />
              </div>

              <div className={clsx(styles.slideBtn)}>
                <Bullets
                  slidesOnly={slidesOnly}
                  slideOnClick={(index) => setGalleryIndex(index)}
                  items={mappedSlides.map((slide) => slide.image)}
                  selectedIndex={galleryIndex}
                />
              </div>
            </Container>
          </BreakOutContainer>
          <Fullscreen
            isFullscreen={fullscreen}
            showCloseButton
            onExit={() => setFullscreen(false)}
            showWhenNotFullscreen={false}
          >
            <ImageGallery
              startIndex={galleryIndex}
              items={mappedSlides.map(({ image }, index) => {
                let id = (image.asset && image.asset._id) || index;
                return {
                  original: `${id}-key`,
                  renderItem: () => (
                    <div onClick={() => imageClicked(index)} className={styles.slideContainer}>
                      <PictureAsset image={image} isFluid height="calc(100vh - 100px)" objectFit="contain" />
                    </div>
                  ),
                  renderThumbInner: () => (
                    <div onClick={() => imageClicked(index)} className={styles.slideThumb}>
                      <PictureAsset breakPoints={[150]} maxWidth={150} image={image} isFluid aspectRatio={1} />
                    </div>
                  ),
                  thumbnailClass: styles.thumbnail,
                };
              })}
            />
          </Fullscreen>
        </>
      )}
    </>
  );
};
